import { Form, Input } from "decorator-form";

import { BlockStylesConfig, blockStylesInput } from "../common/BlockStylesConfig";
import { TypographyStylesConfig, typographyStylesInput } from "../common/TypographyStylesConfig";

@Form({title: "Basic Block View Config"})
export default class BlockViewConfig {

	@Input({type: typographyStylesInput, title: "Text Styles"})
	public typography: TypographyStylesConfig;

	@Input({type: blockStylesInput, title: "Default State"})
	public defaultState: BlockStylesConfig;

}



// WEBPACK FOOTER //
// ./src/common/views/block/BlockConfig.ts